import type React from 'react'

const ThirdPartyPaymentInput: React.FC = () => {
  return <div>A third party has agreed to pay the total rent.</div>
}

export default ThirdPartyPaymentInput
